import restClient from "@/lib/restClient";

const initState = () => ({
  config: null,
  loading: false,
  testResult: null,
  testError: null,
});

export const namespaced = true;

export const state = initState();

export const mutations = {
  SET_CONFIG(state, config) {
    state.config = config;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_TEST_RESULT(state, { result, error }) {
    state.testResult = result;
    state.testError = error || null;
  },
  CLEAR_STATE(state) {
    Object.assign(state, initState());
  },
};

export const actions = {
  async fetchConfig({ commit }, orgId) {
    commit("SET_LOADING", true);
    try {
      const response = await restClient.get(
        `/api/v1/organizations/sso/${orgId}`
      );
      commit("SET_CONFIG", response.data);
      return response.data;
    } catch (error) {
      commit("SET_CONFIG", null);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async saveConfig({ commit }, { orgId, data }) {
    commit("SET_LOADING", true);
    try {
      const response = await restClient.post(
        `/api/v1/organizations/sso/${orgId}`,
        data
      );
      commit("SET_CONFIG", response.data);
      return response.data;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async testConnection({ commit }, orgId) {
    commit("SET_LOADING", true);
    commit("SET_TEST_RESULT", { result: null, error: null });
    try {
      const response = await restClient.post(
        `/api/v1/organizations/sso/${orgId}/test`
      );
      commit("SET_TEST_RESULT", {
        result: response.data?.result,
        error: response.data?.error,
      });
      return response.data;
    } catch (error) {
      commit("SET_TEST_RESULT", { result: "failure", error: error.message });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async toggleEnabled({ commit }, { orgId, enabled }) {
    commit("SET_LOADING", true);
    try {
      const response = await restClient.patch(
        `/api/v1/organizations/sso/${orgId}/toggle`,
        { enabled }
      );
      commit("SET_CONFIG", response.data);
      return response.data;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async toggleEnforced({ commit }, { orgId, enforced }) {
    commit("SET_LOADING", true);
    try {
      const response = await restClient.patch(
        `/api/v1/organizations/sso/${orgId}/enforce`,
        { enforced }
      );
      commit("SET_CONFIG", response.data);
      return response.data;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async parseMetadata(_, { orgId, data }) {
    const response = await restClient.post(
      `/api/v1/organizations/sso/${orgId}/parse-metadata`,
      data
    );
    return response.data;
  },
};

export const getters = {
  config: (state) => state.config,
  loading: (state) => state.loading,
  testResult: (state) => state.testResult,
  testError: (state) => state.testError,
  isEnabled: (state) => state.config?.enabled || false,
  isEnforced: (state) => state.config?.enforced || false,
  lastTestResult: (state) => state.config?.lastTestResult,
};

